import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { useAuth } from "@/contexts/AuthContext";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Play, Clapperboard, Network, Star } from "lucide-react";

const ROLES = [
  { key: "viewer", label: "Viewer", sub: "Watch, rate & join watch-parties", icon: Play, to: "/app/watch" },
  { key: "streamer", label: "Streamer", sub: "Upload films & own your box office", icon: Clapperboard, to: "/app/studio" },
  { key: "artist", label: "Artist", sub: "Network with studios & get hired", icon: Network, to: "/app/network" },
  { key: "influencer", label: "Influencer", sub: "Run deals, pipeline & bookings", icon: Star, to: "/app/factory" },
];

export default function RoleChooser({ open, onOpenChange }) {
  const { refresh } = useAuth();
  const navigate = useNavigate();
  const [busy, setBusy] = useState("");

  const pick = async (r) => {
    setBusy(r.key);
    try {
      await api.setMode(r.key);
      await refresh();
      localStorage.setItem("iw_mode_chosen", "1");
      onOpenChange(false);
      toast.success(`Entering INDIEWOOD as ${r.label}`);
      navigate(r.to);
    } catch { toast.error("Could not set your space"); }
    finally { setBusy(""); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#0F0F0F] border-white/10 text-white max-w-2xl" data-testid="role-chooser">
        <DialogHeader>
          <DialogTitle className="font-sans text-3xl font-extrabold">Log in as…</DialogTitle>
          <DialogDescription className="text-white/50">
            Choose how you want to enter INDIEWOOD. You can switch anytime from your profile.
          </DialogDescription>
        </DialogHeader>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 py-2">
          {ROLES.map(r => (
            <button key={r.key} data-testid={`role-choose-${r.key}`} disabled={!!busy} onClick={() => pick(r)}
              className="text-left border border-white/10 rounded-xl p-5 hover:border-kinetic hover:bg-kinetic/5 transition disabled:opacity-50">
              <r.icon className="w-6 h-6 text-kinetic" />
              <div className="font-sans text-xl font-extrabold mt-3">{r.label}</div>
              <div className="mono text-white/45 mt-1">{r.sub}</div>
            </button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
